import {MouseEvent} from "react";
import {css} from "@panda/css";

import {KM_COMMON_TEST_IDS} from "@pg-mono/test-ids";

import {useMatchedView} from "@/features/km_app/hooks/use_matched_view";
import {NavigationAmplitudeTracker} from "@/features/tracking/amplitude/navigation_amplitude_tracker";
import {waitForAmplitudeFlush} from "@/features/tracking/amplitude/wait_for_amplitude_flush";
import {useRefererData} from "@/hooks/use_referer_data";

import {NAVIGATION_LABELS} from "../constants/navigation_labels";

const isPlainLeftClick = (event: MouseEvent<HTMLAnchorElement>) => event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;

export const GoToPortalButton = () => {
    const {redirectUrl, slug} = useRefererData();
    const viewType = useMatchedView();

    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        NavigationAmplitudeTracker.headerPortalClick(viewType, slug);

        if (!redirectUrl || !isPlainLeftClick(event)) return;

        event.preventDefault();

        void waitForAmplitudeFlush().finally(() => {
            window.location.href = redirectUrl;
        });
    };

    return (
        <a className={buttonStyle} data-testid={KM_COMMON_TEST_IDS.NAV_GO_TO_PORTAL} href={redirectUrl} onClick={handleClick}>
            {NAVIGATION_LABELS.GO_TO_PORTAL}
        </a>
    );
};

const buttonStyle = css({
    alignItems: "center",
    border: "1px solid var(--colors-secondary)",
    borderRadius: "18rem",
    color: "var(--colors-secondary)",
    cursor: "pointer",
    display: "flex",
    flexShrink: 0,
    fontSize: "1.2rem",
    fontWeight: 500,
    height: "3.6rem",
    justifyContent: "center",
    px: 1,
    textDecoration: "none",
    whiteSpace: "nowrap",

    "&:focus-visible": {
        outline: "2px solid var(--colors-info)",
        outlineOffset: "2px"
    }
});
import {MouseEvent} from "react";
import {css} from "@panda/css";

import {KM_COMMON_TEST_IDS} from "@pg-mono/test-ids";

import {useMatchedView} from "@/features/km_app/hooks/use_matched_view";
import {NavigationAmplitudeTracker} from "@/features/tracking/amplitude/navigation_amplitude_tracker";
import {waitForAmplitudeFlush} from "@/features/tracking/amplitude/wait_for_amplitude_flush";
import {useRefererData} from "@/hooks/use_referer_data";

import {NAVIGATION_LABELS} from "../constants/navigation_labels";

const isPlainLeftClick = (event: MouseEvent<HTMLAnchorElement>) => event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;

export const GoToPortalButton = () => {
    const {redirectUrl, slug} = useRefererData();
    const viewType = useMatchedView();

    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
        NavigationAmplitudeTracker.headerPortalClick(viewType, slug);

        if (!redirectUrl || !isPlainLeftClick(event)) return;

        event.preventDefault();

        void waitForAmplitudeFlush().finally(() => {
            window.location.href = redirectUrl;
        });
    };

    return (
        <a className={buttonStyle} data-testid={KM_COMMON_TEST_IDS.NAV_GO_TO_PORTAL} href={redirectUrl} onClick={handleClick}>
            {NAVIGATION_LABELS.GO_TO_PORTAL}
        </a>
    );
};

const buttonStyle = css({
    alignItems: "center",
    border: "1px solid var(--colors-secondary)",
    borderRadius: "18rem",
    color: "var(--colors-secondary)",
    cursor: "pointer",
    display: "flex",
    flexShrink: 0,
    fontSize: "1.2rem",
    fontWeight: 500,
    height: "3.6rem",
    justifyContent: "center",
    px: 1,
    textDecoration: "none",
    whiteSpace: "nowrap",

    "&:focus-visible": {
        outline: "2px solid var(--colors-info)",
        outlineOffset: "2px"
    }
});
